export default function enumValuesClean<T extends Record<string, string>>(
  enumObject: T,
  exclude: string[] = [],
): string[] {
  return Object.values(enumObject).filter((e) => e !== 'UNRECOGNIZED' && !exclude.includes(e));
}
